import React from 'react';

interface AvatarProps {
  src?: string;
  name: string;
  size?: number;
  /** cover pour photos ; contain pour la mascotte Julia */
  fit?: 'cover' | 'contain';
  style?: React.CSSProperties;
}

const Avatar: React.FC<AvatarProps> = ({ src, name, size = 40, fit = 'cover', style }) => {
  const initials = name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  const colors = [
    '#1B2A4A', '#2D5F8A', '#4ECDC4', '#27AE60', '#E67E22',
    '#9B59B6', '#3498DB', '#1ABC9C', '#E74C3C', '#F39C12',
  ];
  const colorIndex = name.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0) % colors.length;

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          objectFit: fit,
          objectPosition: 'center bottom',
          background: fit === 'contain' ? 'var(--color-bg)' : undefined,
          flexShrink: 0,
          ...style,
        }}
      />
    );
  }

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: colors[colorIndex],
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 600,
        fontSize: size * 0.38,
        flexShrink: 0,
        ...style,
      }}
    >
      {initials}
    </div>
  );
};

export default Avatar;
